module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00730.0b8fd2c2.jpg";